export default {
    baseStyle: {
        container: {
            display: 'flex',
            alignItems: 'center'
        },
        label: {
            width: 'full',
            fontSize: '14px'
        },
        control: {
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'gray.200',
            borderRadius: '3px',

            _checked: {
                backgroundColor: 'white',
                borderColor: 'gray.200',
                position: 'relative',

                _before: {
                    content: '"✓"',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: '900',
                    color: 'black',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: '0',
                    left: '0'
                },

                _hover: {
                    backgroundColor: 'white',
                    borderColor: 'gray.200'
                }
            },
            _hover: {
                borderColor: 'gray.200'
            },
            _focus: {
                boxShadow: 'none',
                backgroundColor: 'white',
                borderColor: 'gray.200'
            }
        }
    },

    sizes: {
        md: {
            control: {
                width: '14px',
                height: '14px',
                _invalid: {
                    borderColor: 'gray.200'
                }
            },
            label: {
                marginLeft: 3,
                fontSize: '14px'
            }
        }
    }
}
